export default "__VITE_ASSET__pJHb7WX___"